import {Pipe, PipeTransform} from '@angular/core';
import {NgxFiltersService} from "../ngx-filters.service";
import {Filter} from "../ngx-types";

@Pipe({
  name: 'hasFilter'
})
export class HasFilterPipe implements PipeTransform {
  constructor(private filterService: NgxFiltersService) {

  }

  transform(value: Filter, ...args: any[]): boolean {
    let hasFilter = false;
    if (value) {

      hasFilter = this.filterService.checkHasFilter(value);
    }
    value.hasFilter = hasFilter;
    return hasFilter;
  }

}
